import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import withStyles from "@mui/styles/withStyles";
import { Typography } from "@mui/material";
import { EventStatus } from "../../../models/marine.traffic";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    maxWidth: "120px",
    width: "fit-content",
    padding: "6px 16px",
    height: "24px",
    borderRadius: "20px",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
  },
});

const SimpleBadge = (props: Props) => {
  const { classes, value } = props;

  return (
    <div className={classes.customBadge}>
      <Typography noWrap className={classes.textValue}>
        {value}
      </Typography>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const BadgeProgressStatus = (props: Props) => {
  const { value } = props;
  const { t } = useTranslation();

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return <StyledBadge backgroundColor={backgroundColor} textColor={textColor} value={value} />;

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case EventStatus.IN_PROGRESS:
      return renderBadge(colors.warning50, colors.warning600, t("inProgress").toUpperCase());
    case EventStatus.WAITING:
      return renderBadge("#FEC84B", colors.white, t("waiting").toUpperCase());
    case EventStatus.DONE:
    case EventStatus.DELIVERED:
      return renderBadge(colors.success50, colors.success600, t("delivered").toUpperCase());
    case EventStatus.TRANSSHIPPED:
      return renderBadge(colors.purple50, colors.purple600, t("transshipped").toUpperCase());
    case EventStatus.LOADED:
      return renderBadge(colors.purple50, colors.purple600, t("loaded").toUpperCase());
    case EventStatus.INSPECT:
      return renderBadge(colors.purple50, colors.purple600, t("inspect").toUpperCase());
    default:
      return renderBadge("#308CDB", colors.white, value?.toUpperCase());
  }
};

export default BadgeProgressStatus;
